(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["itech-explore-categories"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sections = document.querySelectorAll('.itcat');

  sections.forEach((root) => {
    if (root.dataset.itcatReady === 'true') return;
    root.dataset.itcatReady = 'true';

    const tracks = root.querySelectorAll('[data-itcat-track]');
    const mobileTrack = root.querySelector('[data-itcat-mobile]');
    const progressThumb = root.querySelector('[data-itcat-progress]');

    const normalizeProgress = (track) => {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      if (max <= 0) return 0;

      let position = track.scrollLeft;
      const rtl = getComputedStyle(track).direction === 'rtl';

      if (rtl) position = Math.abs(position);

      return Math.max(0, Math.min(1, position / max));
    };

    const updateMobileProgress = () => {
      if (!mobileTrack || !progressThumb) return;
      const ratio = normalizeProgress(mobileTrack);
      const rtl = getComputedStyle(mobileTrack).direction === 'rtl';
      const direction = rtl ? -1 : 1;
      progressThumb.style.transform = `translate3d(${direction * ratio * 100}%,0,0)`;
    };

    if (mobileTrack) {
      let progressRaf = 0;
      mobileTrack.addEventListener('scroll', () => {
        cancelAnimationFrame(progressRaf);
        progressRaf = requestAnimationFrame(updateMobileProgress);
      }, { passive: true });

      window.addEventListener('resize', updateMobileProgress, { passive: true });
      requestAnimationFrame(updateMobileProgress);
    }

    tracks.forEach((track) => {
      let dragging = false;
      let didDrag = false;
      let pointerId = null;
      let startX = 0;
      let startScrollLeft = 0;
      let suppressClickUntil = 0;

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;

        dragging = true;
        didDrag = false;
        pointerId = event.pointerId;
        startX = event.clientX;
        startScrollLeft = track.scrollLeft;
        track.classList.add('is-dragging');

        try { track.setPointerCapture(pointerId); } catch (error) {}
      });

      track.addEventListener('pointermove', (event) => {
        if (!dragging || event.pointerId !== pointerId) return;

        const deltaX = event.clientX - startX;
        if (Math.abs(deltaX) > 3) didDrag = true;

        track.scrollLeft = startScrollLeft - deltaX;

        if (event.cancelable) event.preventDefault();
      }, { passive: false });

      const finishDrag = (event) => {
        if (!dragging) return;
        if (event && pointerId !== null && event.pointerId !== pointerId) return;

        dragging = false;
        track.classList.remove('is-dragging');

        if (didDrag) suppressClickUntil = Date.now() + 350;

        try {
          if (pointerId !== null && track.hasPointerCapture(pointerId)) {
            track.releasePointerCapture(pointerId);
          }
        } catch (error) {}

        pointerId = null;
      };

      track.addEventListener('pointerup', finishDrag);
      track.addEventListener('pointercancel', finishDrag);
      track.addEventListener('lostpointercapture', finishDrag);

      track.addEventListener('click', (event) => {
        if (Date.now() > suppressClickUntil) return;
        event.preventDefault();
        event.stopPropagation();
      }, true);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["itech-image-slideshow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('itech-dp-slider')) {
  customElements.define('itech-dp-slider', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.viewport = this.querySelector('[data-iths2-viewport]');
      this.track = this.querySelector('[data-iths2-track]');
      this.originalSlides = Array.from(this.querySelectorAll('[data-iths2-slide]'));
      this.indicators = Array.from(this.querySelectorAll('[data-iths2-to]'));
      this.prevButton = this.querySelector('[data-iths2-prev]');
      this.nextButton = this.querySelector('[data-iths2-next]');
      this.status = this.querySelector('[data-iths2-status]');

      if (!this.viewport || !this.track || !this.originalSlides.length) return;

      this.count = this.originalSlides.length;
      this.current = 0;
      this.width = 0;
      this.initialized = false;
      this.normalizing = false;

      this.mouseDrag = null;
      this.suppressClickUntil = 0;

      this.scrollTimer = null;
      this.scrollFrame = null;
      this.lastSettledLeft = 0;

      this.autoplay = this.dataset.autoplay === 'true' && this.count > 1;
      this.interval = Math.max(3000, Number(this.dataset.interval) || 4000);
      this.autoplayTimer = null;
      this.inView = true;

      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      this.signal = this.abort.signal;

      this.installLoopClones();
      this.bindEvents();
      this.observeVisibility();

      this.resizeObserver = new ResizeObserver(() => this.measure(true));
      this.resizeObserver.observe(this.viewport);

      requestAnimationFrame(() => {
        this.measure(false);
        requestAnimationFrame(() => {
          this.jumpToVisual(this.count > 1 ? 1 : 0);
          this.initialized = true;
          this.lastSettledLeft = this.viewport.scrollLeft;
          this.updateA11y(false);
          this.preloadAround();
          this.scheduleAutoplay();
        });
      });
    }

    disconnectedCallback() {
      this.clearAutoplay();
      clearTimeout(this.scrollTimer);
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.intersectionObserver) this.intersectionObserver.disconnect();
      if (this.abort) this.abort.abort();
      this._ready = false;
    }

    on(node, event, handler, options = {}) {
      if (!node) return;
      node.addEventListener(event, handler, { ...options, signal: this.signal });
    }

    installLoopClones() {
      if (this.count <= 1) {
        this.allSlides = [...this.originalSlides];
        return;
      }

      const firstClone = this.originalSlides[0].cloneNode(true);
      const lastClone = this.originalSlides[this.count - 1].cloneNode(true);

      this.prepareClone(firstClone, 'first');
      this.prepareClone(lastClone, 'last');

      this.track.insertBefore(lastClone, this.originalSlides[0]);
      this.track.appendChild(firstClone);
      this.allSlides = Array.from(this.track.children);
    }

    prepareClone(clone, side) {
      clone.removeAttribute('id');
      clone.removeAttribute('data-iths2-slide');
      clone.removeAttribute('data-block-id');
      clone.removeAttribute('data-slide-index');
      clone.setAttribute('data-iths2-clone', side);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
      clone.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(node => {
        node.setAttribute('tabindex', '-1');
      });
    }

    bindEvents() {
      /* Physical arrows never flip in Arabic. Left = left, right = right. */
      this.on(this.prevButton, 'click', () => this.slideBy(-1, true));
      this.on(this.nextButton, 'click', () => this.slideBy(1, true));

      this.indicators.forEach((indicator, index) => {
        this.on(indicator, 'click', () => this.goTo(index, true));
      });

      this.on(this.viewport, 'keydown', event => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.slideBy(-1, true);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.slideBy(1, true);
        } else if (event.key === 'Home') {
          event.preventDefault();
          this.goTo(0, true);
        } else if (event.key === 'End') {
          event.preventDefault();
          this.goTo(this.count - 1, true);
        }
      });

      /*
        Touch + Mac trackpad are intentionally NOT intercepted.
        The browser supplies native inertial scrolling and scroll-snap, which
        is much closer to Apple's carousel feel and avoids wheel-lock glitches.
      */
      this.on(this.viewport, 'scroll', () => this.onScroll(), { passive: true });
      this.on(this.viewport, 'scrollend', () => this.finishScroll(), { passive: true });

      /* Mouse drag only. Touch remains fully native. */
      this.on(this.viewport, 'pointerdown', event => this.pointerDown(event));
      this.on(this.viewport, 'pointermove', event => this.pointerMove(event), { passive: false });
      this.on(this.viewport, 'pointerup', event => this.pointerUp(event));
      this.on(this.viewport, 'pointercancel', event => this.pointerCancel(event));
      this.on(this.viewport, 'lostpointercapture', event => this.pointerLostCapture(event));

      this.on(this.viewport, 'click', event => {
        if (Date.now() < this.suppressClickUntil) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, { capture: true });

      this.on(document, 'visibilitychange', () => {
        if (document.hidden) this.clearAutoplay();
        else this.scheduleAutoplay();
      });

      if (window.Shopify && window.Shopify.designMode) {
        this.on(document, 'shopify:block:select', event => {
          const blockId = event.detail && event.detail.blockId;
          if (!blockId) return;
          const index = this.originalSlides.findIndex(slide => slide.dataset.blockId === blockId);
          if (index >= 0) this.goTo(index, true, true);
        });
      }
    }

    observeVisibility() {
      if (!('IntersectionObserver' in window)) return;
      this.intersectionObserver = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.inView = Boolean(entry && entry.isIntersecting);
        if (this.inView) this.scheduleAutoplay();
        else this.clearAutoplay();
      }, { threshold: 0.08 });
      this.intersectionObserver.observe(this);
    }

    measure(keepPosition = true) {
      const nextWidth = this.viewport.clientWidth;
      if (!nextWidth) return;

      const changed = Math.abs(nextWidth - this.width) > 0.5;
      this.width = nextWidth;

      if (!changed || !this.initialized || !keepPosition) return;

      /* Keep the active original slide perfectly aligned after resize. */
      this.jumpToVisual(this.count > 1 ? this.current + 1 : 0);
      this.lastSettledLeft = this.viewport.scrollLeft;
    }

    maxVisualIndex() {
      return this.count > 1 ? this.count + 1 : 0;
    }

    nearestVisual() {
      if (!this.width) return this.count > 1 ? this.current + 1 : 0;
      return Math.max(
        0,
        Math.min(this.maxVisualIndex(), Math.round(this.viewport.scrollLeft / this.width))
      );
    }

    logicalFromVisual(visual) {
      if (this.count <= 1) return 0;
      return (visual - 1 + this.count) % this.count;
    }

    jumpToVisual(visual) {
      if (!this.width) return;
      const target = Math.max(0, Math.min(this.maxVisualIndex(), visual));
      this.normalizing = true;
      this.viewport.scrollTo({ left: target * this.width, top: 0, behavior: 'auto' });
      requestAnimationFrame(() => {
        this.normalizing = false;
      });
    }

    smoothToVisual(visual) {
      if (!this.width) return;
      const target = Math.max(0, Math.min(this.maxVisualIndex(), visual));
      this.clearAutoplay();
      this.viewport.scrollTo({
        left: target * this.width,
        top: 0,
        behavior: this.motion.matches ? 'auto' : 'smooth'
      });

      if (this.motion.matches) {
        this.finishScroll();
      }
    }

    onScroll() {
      if (!this.initialized || this.normalizing) return;

      this.clearAutoplay();

      if (!this.scrollFrame) {
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.updateFromPosition();
        });
      }

      /* Fallback for Safari versions without reliable scrollend. */
      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => this.finishScroll(), 130);
    }

    updateFromPosition() {
      const visual = this.nearestVisual();
      const logical = this.logicalFromVisual(visual);
      if (logical !== this.current) {
        this.current = logical;
        this.updateA11y(false);
        this.preloadAround();
      }
    }

    finishScroll() {
      if (!this.initialized || this.normalizing || this.mouseDrag) return;

      clearTimeout(this.scrollTimer);
      this.scrollTimer = null;

      let visual = this.nearestVisual();

      /* Normalize clone edges invisibly after the native snap settles. */
      if (this.count > 1 && visual === 0) {
        this.current = this.count - 1;
        this.jumpToVisual(this.count);
      } else if (this.count > 1 && visual === this.count + 1) {
        this.current = 0;
        this.jumpToVisual(1);
      } else {
        this.current = this.logicalFromVisual(visual);
      }

      this.lastSettledLeft = this.viewport.scrollLeft;
      this.updateA11y(false);
      this.preloadAround();
      this.scheduleAutoplay();
    }

    pointerDown(event) {
      /* Touch/pen stay native. Only add grab-to-drag for a real mouse. */
      if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary) return;

      this.clearAutoplay();

      this.mouseDrag = {
        id: event.pointerId,
        startX: event.clientX,
        startScrollLeft: this.viewport.scrollLeft,
        startVisual: this.nearestVisual(),
        lastX: event.clientX,
        lastTime: performance.now(),
        velocity: 0,
        moved: false
      };

      this.viewport.classList.add('is-dragging');
      try { this.viewport.setPointerCapture(event.pointerId); } catch (_) {}
    }

    pointerMove(event) {
      const p = this.mouseDrag;
      if (!p || event.pointerId !== p.id) return;

      const dx = event.clientX - p.startX;
      if (!p.moved && Math.abs(dx) < 3) return;

      p.moved = true;
      if (event.cancelable) event.preventDefault();

      const now = performance.now();
      const dt = Math.max(1, now - p.lastTime);
      const instantaneous = (event.clientX - p.lastX) / dt;
      p.velocity = p.velocity * 0.72 + instantaneous * 0.28;
      p.lastX = event.clientX;
      p.lastTime = now;

      /* True 1:1 following: the slide stays under the cursor. */
      this.viewport.scrollLeft = p.startScrollLeft - dx;
    }

    pointerUp(event) {
      const p = this.mouseDrag;
      if (!p || event.pointerId !== p.id) return;
      this.endMouseDrag(p, false);
    }

    pointerCancel(event) {
      const p = this.mouseDrag;
      if (!p || event.pointerId !== p.id) return;
      this.endMouseDrag(p, true);
    }

    pointerLostCapture(event) {
      const p = this.mouseDrag;
      if (!p || event.pointerId !== p.id) return;
      this.endMouseDrag(p, true);
    }

    endMouseDrag(p, cancelled) {
      this.mouseDrag = null;
      this.viewport.classList.remove('is-dragging');

      if (!p.moved) {
        this.scheduleAutoplay();
        return;
      }

      this.suppressClickUntil = Date.now() + 380;

      const currentLeft = this.viewport.scrollLeft;
      const projectedLeft = currentLeft - (cancelled ? 0 : p.velocity * 190);
      let targetVisual = Math.round(projectedLeft / Math.max(1, this.width));

      /* One deliberate mouse swipe = max one slide. */
      targetVisual = Math.max(p.startVisual - 1, Math.min(p.startVisual + 1, targetVisual));
      targetVisual = Math.max(0, Math.min(this.maxVisualIndex(), targetVisual));

      requestAnimationFrame(() => this.smoothToVisual(targetVisual));
    }

    slideBy(direction, manual = false) {
      if (this.count <= 1) return;

      this.clearAutoplay();

      /* Always start arrows from an original slide, never from a clone. */
      const baseVisual = this.current + 1;
      const targetVisual = baseVisual + (direction < 0 ? -1 : 1);
      this.smoothToVisual(targetVisual);

      if (manual && this.status) {
        const nextLogical = (this.current + (direction < 0 ? -1 : 1) + this.count) % this.count;
        this.status.textContent = `${this.dataset.slideLabel} ${nextLogical + 1} ${this.dataset.ofLabel} ${this.count}`;
      }
    }

    goTo(index, manual = false, instant = false) {
      if (this.count <= 1) return;

      const target = Math.max(0, Math.min(this.count - 1, Number(index)));
      if (!Number.isFinite(target)) return;

      this.clearAutoplay();

      if (instant || this.motion.matches) {
        this.current = target;
        this.jumpToVisual(target + 1);
        this.updateA11y(manual);
        this.preloadAround();
        this.scheduleAutoplay();
        return;
      }

      this.smoothToVisual(target + 1);

      if (manual && this.status) {
        this.status.textContent = `${this.dataset.slideLabel} ${target + 1} ${this.dataset.ofLabel} ${this.count}`;
      }
    }

    updateA11y(announce = false) {
      this.originalSlides.forEach((slide, index) => {
        const active = index === this.current;
        slide.setAttribute('aria-hidden', String(!active));
        slide.toggleAttribute('inert', !active);
        slide.querySelectorAll('a,button,input,select,textarea').forEach(node => {
          if (active) node.removeAttribute('tabindex');
          else node.setAttribute('tabindex', '-1');
        });
      });

      this.indicators.forEach((indicator, index) => {
        const active = index === this.current;
        indicator.classList.toggle('is-active', active);
        if (active) indicator.setAttribute('aria-current', 'true');
        else indicator.removeAttribute('aria-current');
      });

      if (announce && this.status) {
        this.status.textContent = `${this.dataset.slideLabel} ${this.current + 1} ${this.dataset.ofLabel} ${this.count}`;
      }
    }

    clearAutoplay() {
      if (this.autoplayTimer) {
        clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    scheduleAutoplay() {
      this.clearAutoplay();
      if (!this.autoplay || this.count <= 1 || document.hidden || !this.inView) return;
      if (this.mouseDrag) return;

      this.autoplayTimer = setTimeout(() => {
        this.autoplayTimer = null;
        this.slideBy(1, false);
      }, this.interval);
    }

    preloadAround() {
      if (this.count <= 1) return;

      const indexes = [
        (this.current + 1) % this.count,
        (this.current - 1 + this.count) % this.count
      ];

      indexes.forEach(index => {
        const image = this.originalSlides[index] && this.originalSlides[index].querySelector('img');
        if (image) image.loading = 'eager';
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
